import { applyMiddleware } from 'redux';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import createRootReducers from './rootReducers';
import rootSagas from './rootSagas';
import rootMiddleWares from './rootMiddleWares';

export function configureAppStore() {
  const reduxSagaMonitorOptions = {};
  const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);
  const { run: runSaga } = sagaMiddleware;

  const middleWares = [sagaMiddleware, ...rootMiddleWares];
  const enhancers = [applyMiddleware(...middleWares)];

  const store = configureStore({
    reducer: createRootReducers(),
    middleware: [...getDefaultMiddleware(), ...middleWares],
    devTools: process.env.NODE_ENV !== 'production',
    enhancers,
  });

  runSaga(rootSagas);

  return store;
}
